(ns frontend.ui.component.dynamic-table.row.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]))

(defn default
  [odd-color even-color heading-color]
  ^{:pseudo {":nth-child(odd)"
             {:background-color odd-color}
             ":nth-child(even)"
             {:background-color even-color}}}
  {:background "inherit"})

(defn heading
  [odd-color even-color heading-color]
  ^{:extend default}
  {:border-bottom       "1px solid"
   :border-bottom-color (theme/color [:dynamic-table :heading :border])})

(defn subheading
  [odd-color even-color heading-color]
  ^{:extend      default
    :combinators {[:> :td] {:padding-top    ".75em"
                            :padding-bottom ".75em"}}}
  {:text-transform :uppercase
   :background-color (theme/color [:table :tr :subheading])
   :color (theme/color [:table :tr :subheading-text])})

(defn total
  [odd-color even-color heading-color]
  ^{:extend      default
    :combinators {[:> :td]
                  {:background-color (theme/color [:dynamic-table :total :bg])
                   :border-top       "1px solid" 
                   :border-top-color (theme/color [:dynamic-table :total :border])
                   :color            (theme/color [:dynamic-table :total :fg])}}}
  {:background "inherit"
   :color            (theme/color [:dynamic-table :total :fg])})

(defn subtotal
  [odd-color even-color heading-color]
  ^{:pseudo
    {}
    :extend      default
    :combinators {[:> :td]
                  {:background-color (theme/color [:dynamic-table :sub-total :bg])
                  }
                 }}

  {:background "inherit"
   :color            (theme/color [:dynamic-table :total :fg])})

(defn blank
  [odd-color even-color heading-color]
  ^{:extend      default
    :combinators {[:> :td]
                  {:background-color even-color}}}
  {:background       "inherit"
   :border-top       "1px solid"
   :border-top-color (theme/color [:dynamic-table :blank :border])})

(defn sub-heading?
  [row]
  ; subheading = font underline
  (->> row
       :row-style
       :underline
       (= :single)))

(defn sub-total?
  [row]
  ; subtotal = border top single
  (->> row
       :row-style
       :border-top
       (= :thin)))

(defn total?
  [row]
  ; total = border top double
  (->> row
       :row-style
       :border-top
       (= :double)))

(defn blank?
  [row]
  (nil? row))

(defn class
  [row
   even-row-background-color
   odd-row-background-color
   sub-heading-color]
  (let [style-fn (cond

                   (sub-heading? row)
                   subheading

                   (sub-total? row)
                   subtotal

                   (total? row)
                   total
                   ; extended = empty next line
                   (blank? row)
                   blank
                   ;; default row
                   :else
                   default)]
    (<class (partial style-fn
                     even-row-background-color
                     odd-row-background-color
                     sub-heading-color))))
